import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getPageTemplate } from 'utils/common';
import { setSessionStorage } from 'utils/storageUtils';
import { getAboundToken, getSsoid } from './AboundUtils';

class AboundWidget extends React.Component {
  componentDidMount() {
    document.body.addEventListener('aboundcashwiget-loaded', () => {
      this.setAboundWidget();
    });
    this.setAboundWidget();
  }

  setAboundWidget() {
    if (
      typeof window?.AboundCashWidget !== 'undefined' &&
      typeof window.AboundCashWidget?.init === 'function' &&
      this.getDivId() &&
      // (getAboundToken() || !getSsoid()) &&
      window.geoinfo?.CountryCode === 'US'
    ) {
      if (getAboundToken() && getSsoid()) {
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'registered_user',
          category: 'abound',
          label: `${this.props.type}_nudge`,
        });
      } else if (!getSsoid()) {
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'non_registered_user',
          category: 'abound',
          label: `${this.props.type}_nudge`,
        });
      }

      window.AboundCashWidget.init({
        widgets: [
          {
            ele:
              this.getDivId() === 'abound-floating-btn'
                ? null
                : this.getDivId(),
            widgetType: this.props.widgetType,
            channel: 'TOI',
            platform: this.props.isWapView ? 'msite' : 'web',
            pageName: getPageTemplate(),
          },
        ],
        userLoginInfo: {
          ticketId: getAboundToken(),
        },
      });
    }
  }

  getDivId = () => {
    let divId = null;
    if (this.props.msid) {
      divId = `abound-${this.props.msid}`;
    } else if (this.props.divId) {
      divId = `${this.props.divId}`;
    }

    return divId;
  };

  handleGAEvents = () => {
    setSessionStorage('ga4EventCategoryValue', 'abound');
    if (getAboundToken() && getSsoid()) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'registered_user',
        category: 'abound',
        label: `${this.props.type}_nudge`,
      });
    } else if (!getSsoid()) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'non_registered_user',
        category: 'abound',
        label: `${this.props.type}_nudge`,
      });
    }
  };

  render() {
    return (
      <div
        id={this.getDivId()}
        onClick={this.handleGAEvents}
        className={this.props.className}
      />
    );
  }
}

AboundWidget.propTypes = {
  styleObj: PropTypes.shape({}).isRequired,
  image: PropTypes.shape({}).isRequired,
  msid: PropTypes.string.isRequired,
  styles: PropTypes.shape({}),
};

AboundWidget.defaultProps = {
  styles: {},
};

const mapStateToProps = state => ({
  userAboundData: state.abound ? state.abound.userData : {},
});

export default connect(mapStateToProps)(AboundWidget);
